module.exports = __webpack_public_path__ + "img/gcg_logo.3059b88b.png";